"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("../../../../core/button"));
var _editableField = _interopRequireDefault(require("../../../../core/editable-field"));
var _input = _interopRequireDefault(require("../../../../core/input"));
var _dragHandle = _interopRequireDefault(require("../../../../core/drag-handle"));
var _reactSortableHoc = require("react-sortable-hoc");
var _deleteButton = _interopRequireDefault(require("../../../../core/delete-button"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement(_dragHandle.default, null);
var _ref2 = /*#__PURE__*/_react.default.createElement("td", null);
const RacePhase = (0, _reactSortableHoc.SortableElement)(class extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      loading: false
    });
    _defineProperty(this, "_toggleLoading", () => {
      this.setState({
        loading: !this.state.loading
      });
    });
    _defineProperty(this, "_setLoading", result => {
      this._toggleLoading();
      result.then(() => this._toggleLoading(), () => this._toggleLoading());
    });
    _defineProperty(this, "_onMergeSplitRace", () => {
      this._setLoading(this.props.onMergeSplitRace());
    });
    _defineProperty(this, "_onSplitRace", () => {
      this._setLoading(this.props.onSplitRace());
    });
    _defineProperty(this, "_onChangeDay", () => {
      this._setLoading(this.props.onUpdateRun('competitionDayID', this.props.nextDayID));
    });
    _defineProperty(this, "_onDeleteRun", () => {
      // Cannot use _setLoading here because resetting state.loading for deleted row
      // not possible
      this._toggleLoading();
      this.props.onDeleteRun();
    });
    _defineProperty(this, "_onUpdateSplitPercentage", value => {
      this.props.onUpdateSplitPercentage(value);
    });
    _defineProperty(this, "_onChange", (value, field) => {
      this._setLoading(this.props.onUpdateRun(field, value));
    });
  }
  render() {
    const run = this.props.run;
    return /*#__PURE__*/_react.default.createElement("tr", null, _ref, /*#__PURE__*/_react.default.createElement("td", {
      className: "read-only"
    }, run.race.raceName, run.runSplitNumber === 1 ? ' A' : run.runSplitNumber === 2 ? ' B' : ''), /*#__PURE__*/_react.default.createElement("td", {
      className: "read-only"
    }, run.phaseDescription), /*#__PURE__*/_react.default.createElement("td", {
      className: "read-only"
    }, run.derivedStart), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: true,
      className: "text-xs-right",
      type: "Time",
      name: "fixedStartTime",
      value: run.fixedStartTime,
      onChange: this._onChange
    })), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: true,
      className: "text-xs-right",
      type: "Integer",
      name: "secsAfterPhase",
      value: run.secsAfterPhase,
      required: true,
      onChange: this._onChange
    })), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: true,
      className: "text-xs-right",
      type: "Integer",
      name: "secsBetweenPaddlers",
      value: run.secsBetweenPaddlers,
      required: true,
      onChange: this._onChange
    })), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Checkbox",
      name: "onlyUseHoldingPlaces",
      checked: run.onlyUseHoldingPlaces,
      onChange: this._onChange
    })), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: true,
      className: "text-xs-right",
      type: "Integer",
      name: "holdingPlaces",
      value: run.holdingPlaces,
      required: true,
      onChange: this._onChange
    })), !run.runSplitNumber ? _ref2 : /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right read-only"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: true,
      className: "text-xs-right",
      type: "Integer",
      name: "splitPercentage",
      value: run.splitPercentage,
      required: true,
      onChange: this._onUpdateSplitPercentage,
      suffix: "%"
    })), /*#__PURE__*/_react.default.createElement("td", null, run.runSplitNumber ? /*#__PURE__*/_react.default.createElement(_button.default, {
      size: "sm",
      onClick: this._onMergeSplitRace,
      block: true,
      disabled: this.state.loading
    }, "Merge Split Race") : /*#__PURE__*/_react.default.createElement(_button.default, {
      size: "sm",
      onClick: this._onSplitRace,
      block: true,
      disabled: this.state.loading
    }, "Split Race")), /*#__PURE__*/_react.default.createElement("td", null, !this.props.nextDayID ? null : /*#__PURE__*/_react.default.createElement(_button.default, {
      size: "sm",
      onClick: this._onChangeDay,
      disabled: this.state.loading
    }, "Change Day")), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_deleteButton.default, {
      size: "sm",
      onClick: this._onDeleteRun,
      disabled: this.state.loading
    })));
  }
});

// ****************************************************************************
// PartialQuery definition
// ****************************************************************************

RacePhase.partials = {
  StartListRun: {
    id: true,
    phaseDescription: true,
    competitionDayID: true,
    fixedStartTime: true,
    secsAfterPhase: true,
    secsBetweenPaddlers: true,
    runSplitNumber: true,
    splitPercentage: true,
    holdingPlaces: true,
    onlyUseHoldingPlaces: true,
    race: {
      raceName: true
    }
  }
};

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = (0, _reactBicycle.connect)(RacePhase, undefined, (client, props) => ({
  onUpdateRun(field, value) {
    return client.update('StartListRun.set', {
      id: props.run.id,
      field,
      value
    });
  },
  onDeleteRun() {
    return client.update('StartListRun.delete', {
      runID: props.run.id
    });
  },
  onSplitRace() {
    return client.update('StartListRun.splitRace', {
      runID: props.run.id
    });
  },
  onMergeSplitRace() {
    return client.update('StartListRun.mergeSplitRace', {
      runID: props.run.id
    });
  },
  // setSplitPercentage changes the selected record but also the corresponding record
  // for the other half of the race, which is why the standard .set is not used here
  onUpdateSplitPercentage(value) {
    return client.update('StartListRun.setSplitPercentage', {
      runID: props.run.id,
      value
    });
  }
}));